module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1791972770245.png";